import { render, staticRenderFns } from "./iesps-por-venta-de-cerveza.vue?vue&type=template&id=6059c455&lang=html&"
import script from "./iesps-por-venta-de-cerveza.vue?vue&type=script&lang=js&"
export * from "./iesps-por-venta-de-cerveza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports